module.exports = __webpack_public_path__ + "img/water_count.aaef0581.png";